export const formatFloatValue = (value: number = 0, precision: number = 2) => {
  if (!value || isNaN(value)) {
    const valueZero = 0;
    return valueZero.toFixed(precision).replace(".", ",");
  }
  return value.toFixed(precision).replace(".", ",");
};
